import c from "./lib/createApi";

export default {
  post: c("POST", "/v1/file/upload", true), // [file-1] Image File Upload (이미지 파일 업로드)",
  upload: c("POST", "/v1/file/upload", false),
  saveFileMapping : c("POST", "/v1/file/save-file-mapping", true), //[file-3] File mapping (파일 매핑)
  download : c("GET", "/v1/file/download", true), // [file-4] File download
  getFileMapping: c("GET", "/v1/file/get-file-mapping", true),// [file - 5] fileMapping 조회
  getFileExtension : c("GET", "/v1/file/get-file-extension", true),// [file - 6] 허용 확장자 조회
  stream : c("GET", "/v1/file/stream", true), // [file-7] File stream
  blobVideo : c("GET", "/v1/file/blob-video", true), // [file-8] File blob-video
  getTusFileInfo : c("GET", "/v1/file/tus-file-info", true), // [file-11] TUS 업로드 완료 후 파일 정보 조회
  copyFileMappings : c("POST","/v1/file/file-mappings/copy",true) // [file-11] 파일 매핑 복사
};